import { LenderService } from '@shared/service/lender/lender.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class LenderCodeInterceptor implements HttpInterceptor {
  private urlsToIntercept = ['users/info', 'adminportal/', 'auditlog/', 'cpapi/api/admintoolintegration/updatelenderconfig'];
  constructor(private lenderService: LenderService) {}
  // NOTE: Any changes to this file should also be made in Admin Portal's interceptor to keep them in sync for the sake of the sandbox.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      this.urlsToIntercept.some((item) => {
        return request.url.includes(item);
      })
    ) {
      // URL requires lender code
      const lenderCode = this.lenderService.lenderDataInfo.consumerLoanCode;

      const customReq = request.clone({
        headers: request.headers.set('lenderCode', lenderCode)
      });
      return next.handle(customReq);
    } else {
      return next.handle(request);
    }
  }
}
